module.exports = __webpack_public_path__ + "static/media/arrow left-1.c98b64f3.svg";